import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "./EntrevistaDigital.css";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
const EntrevistaDigital = () => {
    const [cadetes, setCadetes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busqueda, setBusqueda] = useState("");
    const [ordenCampo, setOrdenCampo] = useState("cadeteApellido");
    const [ordenDireccion, setOrdenDireccion] = useState("asc");

    const [filtroRosario, setFiltroRosario] = useState(false);
    const [filtroRecreo, setFiltroRecreo] = useState(false);
    const [filtroRealizo, setFiltroRealizo] = useState(false);
    const [filtroTodos, setFiltroTodos] = useState(true);
    const usuario = ObtieneDatosCookies()
    const activarTodos = () => {
        setFiltroTodos(true);
        setFiltroRosario(false);
        setFiltroRecreo(false);
        setFiltroRealizo(false);
    };

    const desactivarTodos = () => {
        setFiltroTodos(false);
    };
    const generarPDF = async (dni) => {
//         console.log(dni)
        if (!dni) {
            alert("Ingrese al menos un DNI");
            return;
        }

        try {
            setLoading(true);

            // Separar por coma si vienen varios

            // Armar el formato requerido por el backend
            const bodyFormateado = [{
                cadete_dni: String(dni)

            }];

            const response = await fetch(
                "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/generarEntrevistasPDF/",
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(bodyFormateado),
                }
            );

            if (!response.ok) {
                throw new Error("Error al generar el PDF");
            }

            const blob = await response.blob();
            const contentType = response.headers.get("Content-Type");

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download =
                contentType === "application/zip"
                    ? `entrevistas.zip`
                    : `Entrevista_${dni}.pdf`;

            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
            alert("Error generando el archivo");
        } finally {
            setLoading(false);
        }
    };
    const obtenerDatos = async () => {
        try {
            setLoading(true);

            const response = await axios.post(
                "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/obtenerEstadoEntrevistasPromo4",
                {}
            );

            const data = response.data?.data || response.data || [];
            setCadetes(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error obteniendo entrevistas:", err);
            setCadetes([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerDatos();
    }, []);

    // 📊 RESUMEN GENERAL
    const resumen = useMemo(() => {
        const total = cadetes.length;
        const realizados = cadetes.filter(c => c?.realizo === "SI").length;
        const restantes = total - realizados;

        const porSede = {};

        cadetes.forEach(c => {
            const sede = c?.cadeteSede || "Sin sede";

            if (!porSede[sede]) {
                porSede[sede] = { total: 0, realizados: 0 };
            }

            porSede[sede].total += 1;

            if (c?.realizo === "SI") {
                porSede[sede].realizados += 1;
            }
        });

        return { total, realizados, restantes, porSede };
    }, [cadetes]);

    // 🔎 FILTRO + ORDEN
    const cadetesFiltrados = useMemo(() => {
        let lista = [...cadetes];

        // 🔎 Buscador
        if (busqueda.trim() !== "") {
            const texto = busqueda.toLowerCase();

            lista = lista.filter((c) => {
                const dni = String(c?.cadeteDni || "");
                const nombre = String(c?.cadeteNombre || "").toLowerCase();
                const apellido = String(c?.cadeteApellido || "").toLowerCase();

                return (
                    dni.includes(texto) ||
                    nombre.includes(texto) ||
                    apellido.includes(texto)
                );
            });
        }

        // ☑ Filtros checkbox
        if (!filtroTodos) {

            if (filtroRosario) {
                lista = lista.filter(c => c?.cadeteSede === "Rosario");
            }

            if (filtroRecreo) {
                lista = lista.filter(c => c?.cadeteSede === "Recreo");
            }

            if (filtroRealizo) {
                lista = lista.filter(c => c?.realizo === "SI");
            }
        }

        // 🔃 Ordenamiento
        lista.sort((a, b) => {
            let valorA = a?.[ordenCampo] ?? "";
            let valorB = b?.[ordenCampo] ?? "";

            valorA = typeof valorA === "string" ? valorA.toLowerCase() : valorA;
            valorB = typeof valorB === "string" ? valorB.toLowerCase() : valorB;

            if (valorA < valorB) return ordenDireccion === "asc" ? -1 : 1;
            if (valorA > valorB) return ordenDireccion === "asc" ? 1 : -1;
            return 0;
        });

        return lista;

    }, [
        cadetes,
        busqueda,
        ordenCampo,
        ordenDireccion,
        filtroRosario,
        filtroRecreo,
        filtroRealizo,
        filtroTodos
    ]);

    const cambiarOrden = (campo) => {
        if (ordenCampo === campo) {
            setOrdenDireccion(ordenDireccion === "asc" ? "desc" : "asc");
        } else {
            setOrdenCampo(campo);
            setOrdenDireccion("asc");
        }
    };


 const solicitarCorreccion = async (dni) => {
  
    // 🔹 Primer paso: pedir descripción y calificación
    const { value: formValues } = await Swal.fire({
        title: "Solicitar Corrección",
        html: `
            <textarea id="swal-descripcion" class="swal2-textarea" 
                placeholder="Ingrese una breve descripción"></textarea>
            
            <label style="display:block; margin-top:10px;">
                Calificación (1 a 5):
            </label>
            <select id="swal-calificacion" class="swal2-select">
                <option value="">Seleccione...</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </select>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
            const descripcion = document.getElementById("swal-descripcion").value;
            const calificacion = document.getElementById("swal-calificacion").value;

            if (!descripcion || !calificacion) {
                Swal.showValidationMessage("Debe completar todos los campos");
                return false;
            }

            return { descripcion, calificacion };
        }
    });

    if (!formValues) return;

    // 🔹 Segundo paso: confirmación final
    const confirmacion = await Swal.fire({
        title: "¿Está seguro?",
        text: "Una vez enviada la corrección NO podrá editarse.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, enviar",
        cancelButtonText: "Cancelar",
         target: document.body  
    });

    if (!confirmacion.isConfirmed) return;

    try {
        setLoading(true);

        const response = await axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/corregirEntrevista",
            {
                dni: String(dni),
                usuarioCalifico: usuario.identificacion + " - "+ usuario.apellido,
                descripcion: formValues.descripcion,
                calificacion: Number(formValues.calificacion),
                
            }
        );

        const data = response.data?.data || response.data;

        Swal.fire("Éxito", "Corrección generada correctamente ✅", "success");

//         console.log("Respuesta:", data);
        obtenerDatos();

    } catch (err) {
        console.error("Error solicitando corrección:", err.response?.data || err.message);

        Swal.fire("Error", "Error al generar corrección ❌", "error");

    } finally {
        setLoading(false);
    }
};


    const copiarDni = async (dni) => {
       
        try {
            await navigator.clipboard.writeText(dni);
//             console.log("DNI copiado:", dni);
        } catch (err) {
            console.error("Error al copiar:", err);
        }
       window.open('/CadeteEdit?dni=' + dni, '_blank');
    };
const exportarExcel = () => {

    const datos = cadetesFiltrados.map(c => ({
        DNI: c.cadeteDni,
        Apellido: c.cadeteApellido,
        Nombre: c.cadeteNombre,
        Sede: c.cadeteSede,
        Realizo: c.realizo,
        Corregido: c.corregido ? "SI" : "NO",
        IIPPP: c.analisis?.iippp ?? "",
        Nivel: c.analisis?.nivel ?? "",
        Alerta: c.analisis?.alerta_automatica ? "SI" : "NO",
        Califico: c.analisis?.usuarioCalifico ?? ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Entrevistas");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    saveAs(blob, "Entrevistas_Digitales.xlsx");
};
const muestroCorreccion = (cadete) => {
//   console.log(cadete);

  const {
    alerta_automatica,
    calificacion,
    iippp,
    nivel,
    usuarioCalifico,
    visado
  } = cadete.analisis;

  const califNum = parseFloat(calificacion);
  const iipppFinal = parseFloat(iippp);

  // 🔹 Cálculo del IIPPP original
  const iipppOriginal =
    (iipppFinal - (califNum * 0.3)) / 0.7;

  Swal.fire({
    title: "Detalle de Corrección",
    html: `
      <div style="text-align:left;font-size:14px">
        <p><strong>IIPPP Final:</strong> ${iipppFinal.toFixed(3)}</p>
        <p><strong>IIPPP Original:</strong> ${iipppOriginal.toFixed(3)}</p>
        <hr/>
         <p><strong>Nivel:</strong> ${nivel}</p>
        <p><strong>Calificación Manual:</strong> ${calificacion}</p>
       
       
        <p><strong>Entrevista:</strong> ${visado || "-"}</p>
         <p><strong>Alerta automática:</strong> ${alerta_automatica || "-"}</p>
         <p><strong>Usuario que calificó:</strong> ${usuarioCalifico}</p>
       
      </div>
    `,
    icon: "info",
    width: 500,
    confirmButtonText: "Cerrar"
  });
};
    return (
        <div className="digital-container">

            {/* 📊 RESUMEN GENERAL */}
            <div className="digital-resumen-general">
                <div><strong>Total:</strong> {resumen.total}</div>
                <div><strong>Realizados:</strong> {resumen.realizados}</div>
                <div><strong>Restan:</strong> {resumen.restantes}</div>
            </div>
<div style={{ marginBottom: 20, display: "flex", gap: 10 }}>
    <button className="digital-ver" onClick={exportarExcel}>
        Exportar Excel
    </button>

   
</div>
            {/* 📍 RESUMEN POR SEDE */}
            <div className="digital-resumen-sede">
                {Object.entries(resumen.porSede).map(([sede, datos]) => (
                    <div key={sede} className="digital-sede-box">
                        <strong>{sede}</strong>
                        <div>Total: {datos.total}</div>
                        <div>Realizados: {datos.realizados}</div>
                        <div>Restan: {datos.total - datos.realizados}</div>
                    </div>
                ))}
            </div>

            {/* ☑ FILTROS */}
            <div className="digital-filtros">
                <label>
                    <input type="checkbox" checked={filtroTodos} onChange={activarTodos} />
                    Todos
                </label>

                <label>
                    <input
                        type="checkbox"
                        checked={filtroRosario}
                        onChange={() => {
                            setFiltroRosario(!filtroRosario);
                            desactivarTodos();
                        }}
                    />
                    Rosario
                </label>

                <label>
                    <input
                        type="checkbox"
                        checked={filtroRecreo}
                        onChange={() => {
                            setFiltroRecreo(!filtroRecreo);
                            desactivarTodos();
                        }}
                    />
                    Recreo
                </label>

                <label>
                    <input
                        type="checkbox"
                        checked={filtroRealizo}
                        onChange={() => {
                            setFiltroRealizo(!filtroRealizo);
                            desactivarTodos();
                        }}
                    />
                    Realizó
                </label>
            </div>

            {/* 🔎 BUSCADOR */}
            <input
                type="text"
                placeholder="Buscar por DNI, apellido o nombre..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                className="digital-search"
            />

            {loading && <div className="digital-loading">Cargando...</div>}

            {!loading && (
                <>
                    <div className="digital-header">
                        <span >#</span>
                        <span onClick={() => cambiarOrden("cadeteDni")}>DNI</span>
                        <span onClick={() => cambiarOrden("cadeteApellido")}>Apellido Nombre</span>

                        <span onClick={() => cambiarOrden("cadeteSede")}>Sede</span>
                        <span onClick={() => cambiarOrden("realizo")}>Realizó</span>
                        <span onClick={() => cambiarOrden("corregido")}>Corregido</span>
                        <span onClick={() => cambiarOrden("iippp")}>iippp</span>
                        <span onClick={() => cambiarOrden("nivel")}>nivel</span>
                        <span onClick={() => cambiarOrden("alerta_automatica")}>Alerta</span>
                        <span onClick={() => cambiarOrden("usuarioCalifico")}>Califico</span>
                    </div>

                    {cadetesFiltrados.map((c,index) => (

                        <div key={c.cadeteDni} className="digital-row">
                            <span
                              
                                
                            >
                                {index +1}
                            </span>
                            <span
                                className="digital-dni"
                                onClick={() => copiarDni(c.cadeteDni)}
                                style={{ cursor: "pointer", fontWeight: "bold" }}
                            >
                                {c.cadeteDni}
                            </span>

                            <span>{c.cadeteApellido + " " + c.cadeteNombre}</span>

                            <span>{c.cadeteSede}</span>

                            <span>
                                {c.realizo === "SI" ? (<>
                                    <button
                                        className="digital-ver"
                                        onClick={() => generarPDF(c.cadeteDni)}
                                    >
                                        Descargar intento
                                    </button> </>
                                ) : (
                                    <span className="digital-no">NO</span>
                                )}
                            </span>
                            {/* Corrección */}
                            <span>
                                {c.corregido ? (<>
                                    <span className="digital-corregido" onClick={()=>{muestroCorreccion(c)}}>✔ Corregido</span>
                                    </>
                                ) : c.realizo === "SI" ? (
                                    <button
                                        className="btn btn-warning"
                                        onClick={() => solicitarCorreccion(c.cadeteDni)}
                                    >
                                        Corregir
                                    </button>
                                ) : (
                                    "-"
                                )}
                            </span>

                            {/* IIPPP */}
                            <span>{c.analisis?.iippp ?? "-"}</span>

                            {/* Nivel */}
                            <span>
                                {c.analisis?.nivel ? (
                                    <span
                                        className={
                                            c.analisis.nivel == "Estable"
                                                ? "digital-nivel-alto"
                                                : c.analisis.nivel >= "3"
                                                    ? "digital-nivel-medio"
                                                    : c.analisis.nivel >= "2"
                                                        ? "digital-nivel-bajo"
                                                        : ""
                                        }
                                    >
                                        {c.analisis.iippp >= 4
                                            ? "🟢 Estable"
                                            : c.analisis.iippp >= 3
                                                ? "🟠 Preventivo"
                                                : c.analisis.iippp >= 2
                                                    ? "🔴 Intervención"
                                                    : "⚫ Crítico"}
                                    </span>
                                ) : "-"}
                            </span>

                            {/* Alerta */}
                            <span>
                                {c.analisis?.alerta_automatica
                                    ? <span className="digital-norealizo">⚠</span>
                                    : "-"}
                            </span>

 <span>
                                {c.analisis?.usuarioCalifico
                                    ? <span className="digital-norealizo">{c.analisis?.usuarioCalifico}</span>
                                    : "-"}
                            </span>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default EntrevistaDigital;